import TabPane from '../Tabs/pane'
export default TabPane



// WEBPACK FOOTER //
// ./components/TabPane/index.js